import { AuthProvider, AuthProviderProps } from 'react-oidc-context';
import React from 'react';
import { useSession } from '../../modules/session';
import { getAuthUrlFromApiUrl } from '../../../common/api/apiUrlHelpers';

export default function AuthProviderWrapper(props: AuthProviderProps): JSX.Element {
  // Use the auth server corresponding the BIM Track API URL in the session,
  // to allow connecting to different dev environments.
  const { bimTrackApiUrl } = useSession();
  const authority = getAuthUrlFromApiUrl(bimTrackApiUrl) || props.authority;
  const authProviderProps = { ...props, authority } as AuthProviderProps;
  return <AuthProvider {...authProviderProps} />;
}
